import Link from 'next/link'

import type { FC, ReactNode } from 'react'
import type { HubAccent } from '@/types'

import { cn } from '@/lib/utils'
import { accentClasses } from '@/constants/hubs'

interface PillarChipProps {
    accent: HubAccent
    label: string
    href?: string
    className?: string
    // Editable-content reference for the label, e.g. `pillars:<id>:name`.
    cmsRef?: string
}

export const PillarChip: FC<PillarChipProps> = ({
    accent,
    label,
    href,
    className,
    cmsRef
}): ReactNode => {
    const colors = accentClasses(accent)

    const content = (
        <span
            className={cn(
                'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[0.7rem] font-semibold uppercase tracking-[0.1em]',
                colors.bgSoft,
                colors.text,
                href && 'transition-opacity hover:opacity-80',
                className
            )}
        >
            <span className={cn('size-1.5 rounded-full', colors.dot)} />
            <span data-mdlfy-cms={cmsRef}>{label}</span>
        </span>
    )

    if (href) {
        return <Link href={href}>{content}</Link>
    }

    return content
}
